import type { ButtonGroupProps } from './buttonGroup.types'

/** Returns appropriate color for the border between the buttons. */
export function getInnerBorderColor(props: ButtonGroupProps): string {
  const { disabled, variant } = props

  if (disabled) return 'disabled.border'

  return `${variant}`
}
